import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import { initializePwaInstall } from './services/pwa-install'
import { initializeAppUpdates } from './services/update-runtime'
import { pipService } from './services/pip-service'
import App from './App.vue'
import { i18n } from './i18n'
import { router } from './router'
import { initializeRankSync } from './services/rank-api'
import { useAppStore } from './stores/app'
import { useLiveStore } from './stores/live'
import { updateDocumentMetadata } from './seo/document'
import './styles.css'
import './ui/exp-rate-trend.css'
import './ui/exp-rate-chart.css'

if (import.meta.env.DEV) void import('element-plus/dist/index.css')
const disposePwaInstall = initializePwaInstall()

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(ElementPlus)
app.mount('#app')

const appStore = useAppStore(pinia)
const liveStore = useLiveStore(pinia)
initializeRankSync()

watch([() => appStore.locale, () => router.currentRoute.value.path], () => {
  i18n.global.locale.value = appStore.locale
  updateDocumentMetadata(router.currentRoute.value.path, appStore.locale)
}, { immediate: true })

const disposeUpdates = initializeAppUpdates({
  active: () => Boolean(liveStore.session && liveStore.session.status !== 'ended') || liveStore.hasPendingFinalization,
  blocked: () => liveStore.isSelectingWindow || liveStore.firstUseCalibrationBlocking || liveStore.isStarting || liveStore.isEnding,
  finishRecord: () => liveStore.endSession(),
  refreshControls: () => pipService.refresh(),
})
if (import.meta.hot) import.meta.hot.dispose(() => {
  disposeUpdates()
  disposePwaInstall()
})

